<template>
  <div>
    <div class="w-full  mx-auto text-darkBlue mt-24">
      <p class="text-sm pl-3 font-semibold text-center my-3">
        Enter verification code sent to your Email
      </p>
      <div class="w-full  mx-auto mt-4">
        <form class="auth-code-form mt-4" @submit.prevent>
          <div class="flex items-center mx-auto sm:w-full">
            <div>
              <input
                type="text"
                class="single-code-input no-outline"
                placeholder="--"
                maxlength="5"
                v-model="authenticationCode.first"
                @keyup="changeInputField"
                @paste="pasteCode($event)"
                autofocus
              />
              <input
                type="text"
                class="single-code-input no-outline"
                placeholder="--"
                maxlength="1"
                v-model="authenticationCode.second"
                @keyup="changeInputField"
              />
              <input
                type="text"
                class="single-code-input no-outline"
                placeholder="--"
                maxlength="1"
                v-model="authenticationCode.third"
                @keyup="changeInputField"
              />
              <input
                type="text"
                class="single-code-input no-outline"
                placeholder="--"
                maxlength="1"
                v-model="authenticationCode.fourth"
                @keyup="changeInputField"
              />
              <input
                type="text"
                class="single-code-input no-outline"
                placeholder="--"
                maxlength="1"
                v-model="authenticationCode.fifth"
                @keyup="changeInputField"
              />
              <input
                type="text"
                class="single-code-input no-outline"
                placeholder="--"
                maxlength="1"
                v-model="authenticationCode.sixth"
                @keyup="changeInputField"
              />
            </div>
            <div class="verification-status" v-if="codeSubmitted">
              <div class="verification successful" v-if="successfullyVerified">
                <img
                  src="@/assets/images/checkmark.png"
                  alt="checkmark"
                  class="img-fluid"
                />
              </div>
              <div
                class="verification failed cursor-pointer"
                v-else
                @click="resetCodeFields"
              >
                <img
                  src="@/assets/images/cancel.png"
                  alt="checkmark"
                  class="img-fluid"
                />
              </div>
            </div>
          </div>
          <small class="mt-3" v-if="codeSubmitted && !successfullyVerified">
            <span
              class="text-primary-yellow cursor-pointer"
              @click="resendOtp"
              >Resend code</span
            >.</small
          >

          <div class="no-mail">
            <small>
              Didn't get the email?
              <span
                @click="resendOtp"
                class="text-primary-yellow font-medium cursor-pointer"
              >
                Click here
              </span>
            </small>
          </div>
        </form>
      </div>
      <div class="d-flex flex-row-reverse my-3">
        <base-button
          text="Proceed"
          @click="transferOwnership"
        ></base-button>
        <button
          style="width: 157px; height: 48px"
          @click="otpModal = $emit('close-modal')"
          class="border-2 border-black rounded py-1 px-2 font-normal mr-4"
        >
          Cancel
        </button>
      </div>
    </div>

   
  </div>
</template>

<script>
// import AuthLayout from "../Authlayout/OnDemand";
import changeInputField from "@/mixins/changeInput";

export default {
  components: {
    // AuthLayout,
  },
  props:{
    payload:{
      default:()=> null
    },
    transferPayload:{
      default:()=> null
    }
  },

  data() {
    return {
      authenticationCode: {
        first: "",
        second: "",
        third: "",
        fourth: "",
        fifth: "",
        sixth: "",
      },
      password: "",
      password_confirmation: "",
      verifyingAuthCode: false,
      isCreatePassword: false,
      codeSubmitted: false,
      loading: false,
      successfullyVerified: false,
      verificationResent: false,
      resendingVerificationCode: false,
      codeVerified: false,
      userEmail: {},
    };
  },

  mixins: [changeInputField],
  methods: {
    async transferOwnership(){
      this.transferPayload.otp = this.convertAuthCodeToNumbers()
      try{
        await this.$_transferOwnership(this.transferPayload)
        this.$emit('close-modal')
        // this.roleAndPrevelidgeTransferOwnership()
      }catch(error){
        this.handleError()
      }
    },
   async roleAndPrevelidgeTransferOwnership(){
     const payload = {
      userId: this.transferPayload?.newRootAdminId,
      roleId: localStorage.getItem('userId')
     }
     await this.$_roleAndPrevelidgeTransferOwnership(payload)
     this.$emit('close-modal')
   },
  async verifyAuthenticationCode() {
      try {
        this.loading = true;

        const payload = {
          token: this.convertAuthCodeToNumbers(),
          userId: localStorage.getItem("userId"),
          quantumToken: localStorage.getItem("quantumToken"),
        };
console.log(JSON.stringify(payload, null, 2))

        // const response = await this.$_loginWithToken(payload);

        // this.handleSuccessfulResponse(response);
      } catch (error) {
        this.handleError(error);
      } finally {
        this.loading = false;
      }
    },
    async resendOtp() {
      this.generateToast("Resending...", "success");
      try { 
        let response = await this.$_requestOTP(this.payload);
        this.handleSuccessfulCodeResend();
        this.log(response);
      } catch (error) {
        this.handleError(error);
      }
    },
    handleSuccessfulCodeResend() {
      this.resendingVerificationCode = false;
      this.codeSubmitted = false;
      this.verificationResent = true;
      this.generateToast(
        "A new verification code has been sent to your email address!",
        "success"
      );
    },
    convertAuthCodeToNumbers() {
      let {
        first,
        second,
        third,
        fourth,
        fifth,
        sixth,
      } = this.authenticationCode;
      let authCodeNumbers = first + second + third + fourth + fifth + sixth;
      return authCodeNumbers;
    },
    handleSuccessfulResponse({ data: response }) {
        console.log(JSON.stringify(response.data));

      // this.$store.dispatch("handleSuccessfulLogin", response.data);

      // if (response.data.user.onboardingtype === "ondemand") {
      //   this.$router.push("/dashboard");
      // } else {
      //   this.$router.push("/3pl/dashboard");
      // }
    },

    resetCodeFields() {
      this.authenticationCode = {
        first: "",
        second: "",
        third: "",
        fourth: "",
        fifth: "",
        sixth: "",
      };
    },
    pasteCode(e) {
      e.preventDefault();
      const code = e.clipboardData.getData("text/plain");

      if (code.length == 6) {
        this.authenticationCode = {
          first: code.charAt(0),
          second: code.charAt(1),
          third: code.charAt(2),
          fourth: code.charAt(3),
          fifth: code.charAt(4),
          sixth: code.charAt(5),
        };
      } else {
        this.generateToast("Invalid code entered!", "error");
        this.authenticationCode.first = "";
      }
    },
  },
};
</script>

<style scoped>
.single-code-input {
  width: 3.5rem;
  height: 3.75rem;
  background: #ffffff;
  border: 1px solid #b8c4de;
  box-sizing: border-box;
  border-radius: 8px;
  font-size: 1rem;
  margin: 0 0.55rem;
}

.single-code-input::placeholder {
  font-weight: normal;
  font-size: 1rem;
}

.single-code-input[type="text"] {
  font-size: 2.3rem;
  text-align: center;
  font-weight: bold;
  color: rgba(82, 82, 82, 0.3);
}
</style>
